module.exports = __webpack_public_path__ + "static/media/newsletter-december-2023-4.815295ee.jpg";